import { Button, Flex, Box, Tag, VStack, Text, useBoolean, Spinner } from "@chakra-ui/react";
import dayjs from "dayjs";
import { FaPlus, FaPencilAlt, FaEye, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import { useTable, usePagination } from "react-table";
import styled from "@emotion/styled";
import ReactPaginate from "react-paginate";
import { FiChevronDown } from "react-icons/fi";
import { statusOBJ } from "utils/constants";
interface UploadScriptLayoutProp {
  onOpen: () => void;
  deleteMyScript: (id) => void;
  scripts: any;
  loading: boolean;
}

const UploadScriptLayout = (props: UploadScriptLayoutProp) => {
  const history = useNavigate();
  const { onOpen, scripts, deleteMyScript, loading } = props;

  const COLUMNS = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Composer",
      accessor: "composer",
    },
    {
      Header: "Published",
      Cell: ({ cell }: any) => {
        const status = cell.row.original.isVerified;
        const { APPROVED, PENDING, REJECTED } = statusOBJ;
        return (
          <div>
            <Tag
              borderRadius="full"
              bg={status === APPROVED ? "#BBE5B3" : status === REJECTED ? "orangered" : "#FFEA8A"}
              color="#414F3E"
              fontSize="xs"
              textTransform="capitalize"
            >
              {status === APPROVED ? APPROVED : status === REJECTED ? REJECTED : PENDING}
            </Tag>
          </div>
        );
      },
    },
    {
      Header: "Uploaded On",
      Cell: ({ cell }: any) => (
        <div> {dayjs(cell.row.original.createdAt).format("MMM D YYYY")}</div>
      ),
    },
    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Edit",
      Cell: () => (
        <Button>
          {" "}
          <FaPencilAlt />
        </Button>
      ),
    },
    {
      Header: "View",
      Cell: ({ cell }: any) => (
        <Button
          variant="secondary"
          onClick={() => {
            history(`/scripts/${String(cell.row.original.slug)}`);
          }}
        >
          <FaEye />
        </Button>
      ),
    },
    {
      Header: "Delete",
      Cell: ({ cell }: any) => (
        <Button
          bg="orangered"
          onClick={() => {
            deleteMyScript(cell.row.original.id);
          }}
        >
          <FaTrash />{" "}
        </Button>
      ),
    },
  ];

  const columns = useMemo(
    () => COLUMNS,
    // eslint-disable-next-line
    [],
  );
  const data = useMemo(() => scripts.scripts || [], [scripts.scripts]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    canPreviousPage,
    canNextPage,
    // state,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    usePagination,
  );

  // const { pageIndex, pageSize } = state;
  const [showDrop, setDrop] = useBoolean();
  const [currentNo, setcurrentNo] = useState(10);
  return (
    <>
      <VStack mt={4}>
        <Button leftIcon={<FaPlus />} onClick={onOpen}>
          Upload New Script{" "}
        </Button>
      </VStack>
      <Flex justify="center">
        <Box overflowY="scroll" mt="2rem" bg="#fff" p="2">
          <Text
            as="h1"
            fontSize="1.3rem"
            color="#4e6e97"
            margin="0 0 2rem"
            textTransform="uppercase"
          >
            User Script
          </Text>
          <TableWrapper>
            {loading && (
              <div className="spinner-holder">
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="xl"
                />
              </div>
            )}
            <table {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup, index) => (
                  <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => (
                      <th key={index} {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, index) => {
                  prepareRow(row);
                  return (
                    <tr key={index} {...row.getRowProps()}>
                      {row.cells.map((cell, index) => {
                        return (
                          <td key={index} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </TableWrapper>
          <Flex justify="center" mt={1}>
            <small>Table can scroll</small>
          </Flex>

          <Flex alignItems="center" width="100%" justifyContent="flex-end">
            <Button
              variant="unstyled"
              fontWeight="normal"
              // mr="3"
              fontSize="14px"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>
            <PaginationWrapper>
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={({ selected }) => gotoPage(selected)}
                containerClassName={"pagination-container"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"}
              />
            </PaginationWrapper>
            <Button
              variant="unstyled"
              fontWeight="normal"
              mr="3"
              fontSize="14px"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>
            <Box position="relative">
              <Flex
                alignItems="center"
                bg="#fff"
                border="1px solid #d9d9d9"
                borderRadius="2px"
                transition="all .3s cubic-bezier(.645,.045,.355,1)"
                h="32px"
                p="0 11px"
                fontSize="14px"
                onClick={() => {
                  setDrop.toggle();
                }}
              >
                {currentNo} / page <FiChevronDown color="gray" />
              </Flex>
              {showDrop && (
                <Box position="absolute" bg="white" w="100%">
                  {[10, 20, 50, 100].map((btn, index) => (
                    <Button
                      key={index}
                      variant="unstyled"
                      css={{
                        all: "unset",
                        width: "100px",
                        padding: "0 11px",
                        fontSize: "14px",
                        ":hover": {
                          color: "blue",
                          cursor: "pointer",
                        },
                      }}
                      onClick={() => {
                        setPageSize(btn);
                        setDrop.off();
                        setcurrentNo(btn);
                      }}
                    >
                      {btn} / page
                    </Button>
                  ))}
                </Box>
              )}
            </Box>
          </Flex>
        </Box>
      </Flex>
    </>
  );
};
const TableWrapper = styled.div`
  position: relative;
  /* overflow-y:auto; */
  .spinner-holder {
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
  }
  table {
    display: block;
    /* overflow-x: auto; */
    white-space: nowrap;
    th {
      background-color: #edf2f7;
      color: #1d294c;
      padding: 0.8rem;
      text-transform: uppercase;
    }
    td {
      color: #1d294c;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      padding: 15px;
      text-align: center;
    }
  }
`;
const PaginationWrapper = styled.div`
  /* position: relative; */
  /* -----Pagination styles */
  .pagination-container {
    /* position:absolute;
    bottom:0; */
    margin-top: 1rem;
    /* width: 80%; */
    height: 40px;
    list-style: none;
    display: flex;
    /* justify-content: center; */
  }

  .pagination-container a {
    margin: 0 2px 8px;
    border-radius: 6px;
    /* border: 1px solid #2e68c0; */
    color: #2e68c0;
    cursor: pointer;
    font-size: 14px;
    padding: 4px 8px;
    height: 24px;
  }

  .pagination-container a:hover {
    color: white;
    background-color: #2e68c0;
  }

  .paginationActive a {
    color: white;
    background-color: #2e68c0;
  }

  .paginationDisabled a {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
    background-color: transparent;
  }
  /* -----Pagination styles ends */
`;
export default UploadScriptLayout;
